import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
    MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatInputModule,
    MatMenuModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatTabsModule, MatTooltipModule, MatRadioModule, MatAutocompleteModule, MatCardModule
} from '@angular/material';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { TodoListItemService } from './todo-list-item.service';
import { TodoListItemComponent } from './todo-list-item.component';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { TabViewModule, MultiSelectModule, DropdownModule } from 'primeng/primeng';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { TableModule } from 'primeng/table';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { SharedModule } from 'app/shared/shared.module';

const routes: Routes = [
    { path: '', redirectTo: 'todo-list-item', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'todo-list-item', component: TodoListItemComponent, canActivate: [AuthGuardService] }
]

@NgModule({
    declarations: [
        TodoListItemComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatRippleModule,
        MatSelectModule,
        NgxDnDModule,
        FuseSharedModule,
        FuseSidebarModule,
        MatMenuModule,
        MatSidenavModule,
        TabViewModule,
        MatTabsModule,
        MatTooltipModule,
        VirtualScrollerModule,
        TableModule,
        MultiSelectModule,
        MatRadioModule,
        NgxMaterialTimepickerModule,
        MatAutocompleteModule,
        RichTextEditorAllModule,
        SharedModule,
        MatCardModule,
        DropdownModule
    ],
    exports: [],
    providers: [
        TodoListItemService
    ]
})

export class TodoListItemModule {

}
